import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { n_ai_speaking } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useConversationAIStack } from '../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const ConversationNotificationBody = dynamic(
  () => import('../../new-portal/conversational-ai/ConversationNotification'),
  {
    loading: () => (
      <div className="flex h-screen w-screen items-center justify-center">
        <LoadingSpinner lg show primary />
      </div>
    ),
  }
)

const ConversationNotificationActivity: ActivityComponentType = () => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { push, pop } = useConversationAIFlow()
  const { t } = useTranslation()

  return (
    <WebviewStackContainer height="52px" border={false} onBack={pop} title={t(n_ai_speaking.noti.page_title)}>
      <div className="px-[16px]">
        <ConversationNotificationBody />
      </div>
    </WebviewStackContainer>
  )
}

export default ConversationNotificationActivity
